export default defineNuxtPlugin(() => {
    if (!import.meta.dev) {
        return;
    }

    const { activeSite, host } = useMultisite();
    const site = activeSite.value;

    // eslint-disable-next-line no-console
    console.info('[multisite] matched site', JSON.stringify({
        host,
        handle: site.handle,
        group: site.group,
        locale: site.locale,
        name: site.name,
        heroLottie: site.enable?.includes('hero-lottie') ?? false,
    }));
});
